/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import CreatePassword from '../create-password/create-password';
import FormValidator from '../../../../utilities/formValidator';
import './reset-password.scss';
import useIsDesktop from '../../../../utilities/hooks/useIsDesktop';
import GlobalError from '../../../shared/blocks/global-error/global-error';
import PrimaryButton from '../../../shared/buttons/primary-button/primary-button';

const ResetPassword = () => {
  const isDesktop = useIsDesktop();
  const [userEmail, setUserEmail] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isThereAnError, setIsThereAnError] = useState(false);
  const formValidator = FormValidator();

  const queryParams = new URLSearchParams(window.location.search);
  const verify = queryParams?.get('verify');
  const email = queryParams?.get('email');

  useEffect(() => {
    if (verify && email) {
      setUserEmail(email);
      setIsSubmitted(true);
    }
  }, [verify, email]);

  const systemTimeoutCallback = () => {
    setIsSubmitted(false);
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const validateForm = formValidator.formValidate();
      // eslint-disable-next-line no-shadow
      if (!userEmail) {
        setUserEmail(validateForm.email);
      }

      const result = await Auth.forgotPassword(userEmail || validateForm.email);
      if (result) {
        if (!isSubmitted) {
          setIsSubmitted(true);
        }
        setIsLoading(false);
      }
    } catch (error) {
      setIsThereAnError(true);
      formValidator.errorHandling(error);
    }
  };

  return (
    <div className="password-page bg-white c-light-midnight p-x-content mw-s lh-150 m-b-48">
      <div className={`${isDesktop ? 'full-border' : ''}`}>
        {!isSubmitted && (
          <div>
            <div className="m-b-s">
              <h2 className="ff-wallop c-purple-primary fs-h4 lh-110">Reset Your Password</h2>
            </div>
            <GlobalError>
              <p className="c-utility-red fs-p2">Max reset password attempts met. Please wait 24-48 hours to reset again.</p>
            </GlobalError>
            <div className="modal-body m-b-xs">
              <p className="ff-graphik fw-normal please-reset-text fs-p2">Please enter your email address below. You will receive a link to reset your password.</p>
              <form className="d-flex-column m-t-16" onSubmit={resetPassword}>
                <div className="form-input m-b-xs">
                  <label className="fs-p3 ff-graphik m-b-8" htmlFor="email" aria-required="true" aria-labelledby="emailError">Email</label>
                  <input className="input " id="email" name="email" type="email" defaultValue={userEmail} required />
                  <div className="m-t-8 error warn jsAuthErrorEmailExtra jsEmailExceptionExtra jsInvalidParameterEmailExceptionExtra d-none" id="emailError" />
                </div>
                <div className="m-b-s">
                  <PrimaryButton
                    onClick={resetPassword}
                    isLoading={isLoading}
                    title="Reset Password"
                    buttonType="submit"
                  />
                </div>
              </form>
              <p className="ff-graphik-medium fw-normal fs-p2 need-help">Need more help?</p>
              <div className="ff-graphik fs-p2 lh-24 customer-care-link m-t-4">
                If you're still having difficulty logging into your account, please call our customer service representatives at
                <a className="c-light-midnight td-underline td-none phone-number-link m-r-8" href="tel:18888488456">888-848-8456</a>
              </div>
            </div>
          </div>
        )}
        {isSubmitted && <CreatePassword userEmail={userEmail} verify={verify} resetPasswordCallback={resetPassword} timeoutCallback={systemTimeoutCallback} isThereAnError={isThereAnError} />}
      </div>
    </div>
  );
};

export default ResetPassword;
